module.exports = __webpack_public_path__ + "assets/minus.6194a577.svg";